import React from 'react'

const AGRUPADOR = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 })

export function soloDigitos(texto: string): number {
  const limpio = texto.replace(/\D/g, '')
  return limpio === '' ? 0 : Number(limpio)
}

export function formatearMiles(valor: number): string {
  if (!valor || isNaN(valor)) return '0'
  return AGRUPADOR.format(Math.round(valor))
}

type Props = {
  valor: number
  onCambio: (valor: number) => void
  className?: string
  placeholder?: string
  title?: string
  id?: string
  disabled?: boolean
  required?: boolean
  style?: React.CSSProperties
}

export function CampoPesos({
  valor,
  onCambio,
  className,
  placeholder = '0',
  title,
  id,
  disabled,
  required,
  style,
}: Props) {
  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      className={className}
      style={style}
      disabled={disabled}
      required={required}
      title={title}
      placeholder={placeholder}
      value={valor === 0 ? '' : AGRUPADOR.format(valor)}
      onFocus={(e) => e.currentTarget.select()}
      onChange={(e) => onCambio(soloDigitos(e.target.value))}
    />
  )
}

